import { NgModule } from '@angular/core';

import { MenuItems } from './menu-items/menu-items';
import { HorizontalMenuItems } from './menu-items/horizontal-menu-items';
import { AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective } from './accordion';
import { ToggleFullscreenDirective } from './fullscreen/toggle-fullscreen.directive';
import { PipesModule } from '../pipes/pipes.module';
import { TimezoneSelectorComponent } from './timezone-selector/timezone-selector.component';
import { AppMaterialModule } from '../app-material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DeleteDialogComponent } from './delete-dialog/delete.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

@NgModule({
  imports: [
    PipesModule,
    AppMaterialModule,
    ReactiveFormsModule,
    CommonModule,
    FlexLayoutModule
  ],
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ToggleFullscreenDirective,
    TimezoneSelectorComponent,
    DeleteDialogComponent
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ToggleFullscreenDirective,
    TimezoneSelectorComponent
  ],
  providers: [MenuItems, HorizontalMenuItems]
})
export class SharedModule {}
